'use es6';

import { Map as ImmutableMap } from 'immutable';
class ModuleEditorStore {
  constructor() {
    this.store = new ImmutableMap();
  }
  delete(key) {
    this.store = this.store.delete(key);
  }
  deleteAll(keys) {
    keys.forEach(k => this.store = this.store.delete(k));
  }
  set(key, val) {
    this.store = this.store.set(key, val);
  }
  get(key) {
    return this.store.get(key);
  }
}
export default new ModuleEditorStore();